module.exports = __webpack_public_path__ + "static/media/promocoes-proximas-mobile.0c2b7ce1.jpg";